import { CalendarCheck, ShieldCheck, Users } from "lucide-react";

export function SmallCheckoutNavbar({
  dealLabel = 'LIMITED LIFETIME DEALS AVAILABLE',
  accessLabel = 'LIFETIME ACCESS',
}: {
  dealLabel?: string;
  accessLabel?: string;
}) {
  return (
    <div className="border-b shadow-sm">
      {/* Top Bar */}
      <div className="bg-gradient-to-r from-white to-gray-50">
        <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-between px-4 py-2">
          {/* Logo */}
          <img
            src="/lovable-uploads/bookstera_logo.png"
            alt="Bookstera Logo"
            className="h-12 mb-2 sm:mb-0"
          />

          {/* Deal Alert */}
          <div className="text-center sm:ml-4">
            <span className="bg-gradient-to-r from-orange-500 to-red-500 text-white px-3 py-1 rounded-full text-xs sm:text-sm font-bold shadow-md animate-pulse">
              {dealLabel}
            </span>
          </div>
        </div>
      </div>

      {/* Guarantee / Benefits Bar */}
      <div className="bg-gray-100 border-t">
        <div className="max-w-7xl mx-auto flex flex-col sm:flex-row justify-around items-center text-center px-4 py-3 gap-2 sm:gap-0">
          <div className="flex items-center gap-2 text-xs sm:text-sm font-medium text-gray-700">
            <ShieldCheck className="h-4 w-4 text-green-600" />
            <span>{accessLabel}</span>
          </div>
          <div className="flex items-center gap-2 text-xs sm:text-sm font-medium text-gray-700">
            <CalendarCheck className="h-4 w-4 text-blue-600" />
            <span>90-DAY MONEY-BACK GUARANTEE</span>
          </div>
          <div className="flex items-center gap-2 text-xs sm:text-sm font-medium text-gray-700">
            <Users className="h-4 w-4 text-purple-600" />
            <span>5200+ Happy Authors</span>
          </div>
        </div>
      </div>
    </div>
  );
}
